import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-signature-and-initial-type',
  templateUrl: './signature-and-initial-type.component.html',
  styleUrls: ['./signature-and-initial-type.component.scss'],
})
export class SignatureAndInitialTypeComponent implements OnInit, OnChanges {
  public signatureNameControl: FormControl = new FormControl('');
  public valueTypeMaxLength: number = 2048;
  public message: string = null;

  private isChanged: boolean = false;
  private currentFont: string;
  private currentType: number;

  @Input() context: any;
  @Input() dataTypes: any;
  @Input() fonts: any;
  @Input() color: string;

  @Output() selectedItem = new EventEmitter<any>();
  @Output() isEmptyText = new EventEmitter<boolean>();

  @ViewChild('enter') enterRef;

  constructor() {}

  ngOnInit(): void {
    this.signatureNameControl.setValue(this.context.model.tabs[this.dataTypes.Type].data);

    if (this.currentType && this.currentFont) {
      this.selectedItem.emit({
        font: this.currentFont,
        tabType: this.currentType,
        color: this.color,
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.color = changes.color.currentValue;
  }

  public clearFiled(): void {
    this.signatureNameControl.setValue('');
    this.isEmptyText.emit(true);
  }

  public setData(event, tabType: number): void {
    if (!event) {
      return;
    }

    !event.data ? this.isEmptyText.emit(true) : this.isEmptyText.emit(false);

    this.message = null;

    this.context.model.tabs[tabType].data = event.data;

    if (event.fileId) {
      this.context.model.tabs[tabType].fileId = event.fileId;
    }

    this.isChanged = event.data ? true : false;

    if (tabType !== this.dataTypes[tabType]) {
      this.enterRef.nativeElement.focus();
    }
  }

  public onSelectedType(font, type): void {
    this.currentFont = font;
    this.currentType = type;

    this.context.model.tabs[type].styles.font = font;
    this.context.model.tabs[type].styles.color = this.color;
    this.selectedItem.emit({ font, tabType: type, color: this.color });
  }
}
